module.exports = __webpack_public_path__ + "a7aab4db26cc94394b715fdd1a50c5ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/face/plugin/images/google-3.png
// module id = 906
// module chunks = 3